// API Configuration
const resolveDefaultApiBase = (): string => {
  // During SSR/build, keep local fallback.
  if (typeof window === 'undefined') return 'http://localhost:8080';

  const { protocol, hostname, origin } = window.location;
  const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1';

  // Local frontend commonly runs on :3000 while backend runs on :8080.
  if (isLocalHost) return `${protocol}//${hostname}:8080`;

  // Production/staging should use same-origin API unless explicitly overridden.
  return origin;
};

export const API_BASE_URL = process.env.REACT_APP_API_URL || resolveDefaultApiBase();
export const GEOAPIFY_API_KEY = '0d904b4293704158b1c31cc8f99c157f';

// Helper function to build API URLs
export const buildApiUrl = (endpoint: string): string => {
  if (!endpoint) return API_BASE_URL;
  if (/^https?:\/\//i.test(endpoint)) return endpoint;

  const base = String(API_BASE_URL || '').replace(/\/+$/, '');
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${base}${path}`;
};

// Authorization header helper
export const authHeaders = (): Record<string, string> => {
  try {
    const token =
      localStorage.getItem('auth_token') ||
      sessionStorage.getItem('auth_token') ||
      localStorage.getItem('admin_token') ||
      sessionStorage.getItem('admin_token') ||
      '';
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
};